import React, { useState, useRef, useEffect } from "react";
import api from "components/api/api";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";

const isDev = process.env.NODE_ENV === "development";

export default function Mongologin() {
  const history = useHistory();
  const isMountedRef = useRef(true);

  const [staffId, setStaffId] = useState(isDev ? "67741" : "");
  const [loading, setLoading] = useState(false);
  const [staffIdError, setStaffIdError] = useState("");

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  const validateStaffId = (v) => {
    if (!v) return "Staff ID is required";
    if (v.length < 3 || v.length > 20) return "Must be 3–20 characters";
    if (!/^[a-zA-Z0-9]+$/.test(v)) return "Alphanumeric only";
    return "";
  };

  const handleLogin = async () => {
    const err = validateStaffId(staffId);
    if (err) {
      setStaffIdError(err);
      return;
    }

    setLoading(true);
    try {
      const res = await api.mongoLogin(staffId);
      if (!isMountedRef.current) return;

      const data = res.data?.data;
      if (res.data?.success && data) {
        // Store user session
        localStorage.setItem("token", data.clientId);
        localStorage.setItem("clientId", JSON.stringify(data.clientId));
        localStorage.setItem("userId", data.clientId);
        localStorage.setItem("username", data.staff_name);
        localStorage.setItem("is_admin", data._admin ? "true" : "false");
        localStorage.setItem("userRole", data.userRole);
        localStorage.setItem("Name", data.staff_name);
        localStorage.setItem("Outlet", data.staff_outlet);
        localStorage.setItem("Region", data.staff_region);
        localStorage.setItem("Position", JSON.stringify(data.staff_position));

        history.replace(`${process.env.PUBLIC_URL}/quiz-survey`);
      } else {
        Swal.fire({
          icon: "error",
          text: res.data?.message || "Login failed",
          timer: 2500,
        });
      }
    } catch (e) {
      if (!isMountedRef.current) return;
      // Server returns error message in e.data.message (from api.js interceptor)
      const msg = e?.data?.message || e?.message || "User not found";
      Swal.fire({ icon: "error", text: msg, timer: 2500 });
    } finally {
      if (isMountedRef.current) setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:wght@300;400;500&display=swap');

        .ml-root {
          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #0a0a0a;
          font-family: 'DM Sans', sans-serif;
          overflow: hidden;
          position: relative;
        }

        .ml-grid {
          position: absolute;
          inset: 0;
          background-image:
            linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
          background-size: 48px 48px;
          pointer-events: none;
        }

        .ml-glow {
          position: absolute;
          width: 600px;
          height: 600px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(0,200,120,0.07) 0%, transparent 65%);
          top: -150px;
          right: -100px;
          pointer-events: none;
        }

        .ml-glow2 {
          position: absolute;
          width: 400px;
          height: 400px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(0,160,255,0.06) 0%, transparent 65%);
          bottom: -100px;
          left: -80px;
          pointer-events: none;
        }

        .ml-card {
          position: relative;
          z-index: 1;
          width: 420px;
          background: #111;
          border: 1px solid #222;
          border-radius: 16px;
          padding: 40px;
          box-shadow: 0 0 0 1px rgba(255,255,255,0.03), 0 40px 80px rgba(0,0,0,0.6);
        }

        .ml-badge {
          display: inline-flex;
          align-items: center;
          gap: 6px;
          background: rgba(0,200,120,0.1);
          border: 1px solid rgba(0,200,120,0.2);
          border-radius: 20px;
          padding: 4px 12px;
          font-size: 11px;
          font-weight: 500;
          color: #00c878;
          letter-spacing: 0.06em;
          text-transform: uppercase;
          margin-bottom: 20px;
        }

        .ml-badge-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #00c878;
          animation: ml-pulse 2s ease-in-out infinite;
        }

        @keyframes ml-pulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.4; transform: scale(0.8); }
        }

        .ml-title {
          font-family: 'Syne', sans-serif;
          font-size: 28px;
          font-weight: 800;
          color: #f0f0f0;
          margin: 0 0 6px;
          letter-spacing: -0.5px;
          line-height: 1.2;
        }

        .ml-subtitle {
          font-size: 13px;
          color: #555;
          margin: 0 0 32px;
          font-weight: 300;
        }

        .ml-label {
          display: block;
          font-size: 11px;
          font-weight: 500;
          color: #666;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          margin-bottom: 8px;
        }

        .ml-input-wrap {
          position: relative;
          margin-bottom: 6px;
        }

        .ml-input {
          width: 100%;
          background: #0d0d0d;
          border: 1px solid #2a2a2a;
          border-radius: 8px;
          color: #e8e8e8;
          font-family: 'DM Sans', sans-serif;
          font-size: 15px;
          font-weight: 400;
          padding: 12px 16px;
          outline: none;
          box-sizing: border-box;
          transition: border-color 0.2s;
        }

        .ml-input:focus {
          border-color: #00c878;
          box-shadow: 0 0 0 3px rgba(0,200,120,0.08);
        }

        .ml-input.error {
          border-color: #e24b4a;
        }

        .ml-input:disabled {
          opacity: 0.4;
          cursor: not-allowed;
        }

        .ml-error {
          font-size: 12px;
          color: #e24b4a;
          margin: 4px 0 16px;
          min-height: 16px;
        }

        .ml-otp-row {
          display: flex;
          gap: 8px;
          margin-bottom: 8px;
        }

        .ml-otp-cell {
          flex: 1;
          background: #0d0d0d;
          border: 1px solid #2a2a2a;
          border-radius: 8px;
          color: #e8e8e8;
          font-family: 'Syne', sans-serif;
          font-size: 20px;
          font-weight: 700;
          text-align: center;
          padding: 14px 0;
          outline: none;
          transition: border-color 0.2s, background 0.2s;
          width: 0;
          caret-color: #00c878;
        }

        .ml-otp-cell:focus {
          border-color: #00c878;
          background: #0f1a14;
          box-shadow: 0 0 0 3px rgba(0,200,120,0.08);
        }

        .ml-otp-cell.filled {
          border-color: #2e6e4a;
          background: #0d1a12;
        }

        .ml-btn {
          width: 100%;
          background: #00c878;
          color: #000;
          font-family: 'Syne', sans-serif;
          font-size: 14px;
          font-weight: 700;
          letter-spacing: 0.04em;
          border: none;
          border-radius: 8px;
          padding: 14px;
          cursor: pointer;
          transition: background 0.2s, transform 0.1s, opacity 0.2s;
          margin-top: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .ml-btn:hover:not(:disabled) { background: #00e68a; }
        .ml-btn:active:not(:disabled) { transform: scale(0.98); }
        .ml-btn:disabled { opacity: 0.35; cursor: not-allowed; }

        .ml-btn-ghost {
          background: transparent;
          color: #444;
          border: 1px solid #222;
          width: 100%;
          font-family: 'DM Sans', sans-serif;
          font-size: 13px;
          font-weight: 400;
          border-radius: 8px;
          padding: 10px;
          cursor: pointer;
          transition: border-color 0.2s, color 0.2s;
          margin-top: 10px;
        }

        .ml-btn-ghost:hover { border-color: #444; color: #888; }

        .ml-footer-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 16px;
        }

        .ml-link {
          font-size: 12px;
          color: #444;
          cursor: pointer;
          transition: color 0.15s;
          background: none;
          border: none;
          padding: 0;
          font-family: 'DM Sans', sans-serif;
        }

        .ml-link:hover { color: #00c878; }
        .ml-link:disabled { color: #2a2a2a; cursor: not-allowed; }

        .ml-hint {
          font-size: 12px;
          color: #333;
          text-align: center;
          margin-top: 24px;
          line-height: 1.6;
        }

        .ml-spinner {
          width: 16px;
          height: 16px;
          border: 2px solid rgba(0,0,0,0.2);
          border-top-color: rgba(0,0,0,0.8);
          border-radius: 50%;
          animation: ml-spin 0.6s linear infinite;
          flex-shrink: 0;
        }

        @keyframes ml-spin {
          to { transform: rotate(360deg); }
        }

        .ml-stage-enter {
          animation: ml-enter 0.22s ease-out;
        }

        @keyframes ml-enter {
          from { opacity: 0; transform: translateY(8px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      <div className="ml-root">
        <div className="ml-grid" />
        <div className="ml-glow" />
        <div className="ml-glow2" />

        <div className="ml-card">
          <div className="ml-badge">
            <span className="ml-badge-dot" />
            Omantel SIP
          </div>

          <div className="ml-stage-enter">
            <h1 className="ml-title">Welcome back</h1>
            <p className="ml-subtitle">Enter your Staff ID to sign in</p>

            <label className="ml-label" htmlFor="staffId">
              Staff ID
            </label>
            <div className="ml-input-wrap">
              <input
                id="staffId"
                className={`ml-input${staffIdError ? " error" : ""}`}
                type="text"
                value={staffId}
                autoComplete="off"
                placeholder="e.g. 69925"
                maxLength={20}
                onChange={(e) => {
                  setStaffId(e.target.value);
                  setStaffIdError(validateStaffId(e.target.value));
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") handleLogin();
                }}
                disabled={loading}
              />
            </div>
            <p className="ml-error">{staffIdError}</p>

            <button
              className="ml-btn"
              onClick={handleLogin}
              disabled={loading || !staffId || !!staffIdError}
            >
              {loading ? <span className="ml-spinner" /> : null}
              {loading ? "Signing in…" : "Sign In →"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
